var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"calc(100vh - 496px - 48px)"}},[_c('DefaultSelfNonOpenForm',{attrs:{"type":"P"},model:{value:(_vm.playerList[0]),callback:function ($$v) {_vm.$set(_vm.playerList, 0, $$v)},expression:"playerList[0]"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }